import { jsx as _jsx } from "react/jsx-runtime";
export const FullWidth = ({ id, testId, children }) => {
    return (_jsx("div", { id: id, "data-test-id": testId, "data-eco-component": "full-width", className: "py-3", children: _jsx("div", { className: "mx-auto w-screen px-4 py-3 sm:px-6 md:-ml-20 md:px-8 md:pl-28", children: _jsx("div", { className: "py-3", children: children }) }) }));
};
export default FullWidth;
